module.exports = __webpack_public_path__ + "img/group.df9a471b.jpeg";